// extracted by mini-css-extract-plugin
export default {"Modal":"RemoveReaderLoginModal_Modal__pHsUd"};